import { render, staticRenderFns } from "./SocialNetworks.vue?vue&type=template&id=a9d7266e"
import script from "./SocialNetworks.vue?vue&type=script&lang=js"
export * from "./SocialNetworks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports